import { NAF_INSURANCE_TASK_CHIP_TEXT } from 'utilities/Constant';
import Pill from '../pill/pill';

export default function NafInsuranceChip() {
  return (
    <Pill text={NAF_INSURANCE_TASK_CHIP_TEXT} variant="insurance" />
  );
}